import React, { useState } from "react";
import { AdhocAgreementsErrorBanner } from "../ErrorBanner";
import { Grid, Typography } from "@material-ui/core";
import PageHeader from "../../shared/Header";
import AdhocAgreementsContent from "./Content";
import { Link } from "react-router-dom";
import { Add, Folder } from "@material-ui/icons";

export const AdhocAgreementsPage: React.FC = () => {
  const [error, setError] = useState("");
  const [bannerIsVisible, setBannerIsVisible] = useState(false);

  return (
    <div>
      <AdhocAgreementsErrorBanner
        handleBannerDismiss={() => setBannerIsVisible(false)}
        error={error}
        showBanner={bannerIsVisible}
      />
      <Grid container>
        <PageHeader
          title="Adhoc Agreement Portal"
          rightContent={
            <div style={{ display: "flex", gap: "40px" }}>
              <Link to="/adhoc-projects">
                <Typography style={{ display: "flex", alignItems: "center" }}>
                  Manage Projects <Folder style={{ marginLeft: "10px" }} />
                </Typography>
              </Link>
              <Link to="/adhoc-agreements/new">
                <Typography style={{ display: "flex", alignItems: "center" }}>
                  New Agreement <Add style={{ marginLeft: "10px" }} />
                </Typography>
              </Link>
            </div>
          }
        />
        <AdhocAgreementsContent />
      </Grid>
    </div>
  );
};

export default AdhocAgreementsPage;
